export const CONFIG = {
    FETCH_BEGIN: 'thirdPartyContentTypes/FETCH_CONFIG_BEGIN',
    FETCH_SUCCESS: 'thirdPartyContentTypes/FETCH_CONFIG_SUCCESS',
    FETCH_ERROR: 'thirdPartyContentTypes/FETCH_CONFIG_ERROR',
};
export const POSTS = {
    FETCH_BEGIN: 'thirdPartyContentTypes/FETCH_POSTS_BEGIN',
    FETCH_SUCCESS: 'thirdPartyContentTypes/FETCH_POSTS_SUCCESS',
    FETCH_ERROR: 'thirdPartyContentTypes/FETCH_POSTS_ERROR',
    RESET_POSTS: 'thirdPartyContentTypes/RESET_POSTS',
};
export const SET_BLOCK_POPULATING = 'thirdPartyContentTypes/SET_BLOCK_POPULATING';
